import React, { useState } from 'react'

import './App.scss'

import Layout from './components/Layout'

import Introduction from './views/Introduction'
import Form from './views/Form'
import Health from './views/Health'
import Conditions from './views/Conditions'
import Instructions from './views/Instructions'
import Record from './views/Record'
import Finish from './views/Finish'
import { requestMicPermission } from './microphone'
import Symptoms from './views/Symptoms'

const logo = require('./voicemed.png')

const STEPS = {
  introduction: 1,
  form: 2,
  health: 3,
  conditions: 4,
  symptoms: 5,
  instructions: 6,
  record: 7,
  done: 8
}

const App = ({ step, setStep, data, setData, blobs, addBlob }) => {
  const components = {
    [STEPS.introduction]: <Introduction onNext={() => setStep(STEPS.form)} />,
    [STEPS.form]: (
      <Form
        data={data}
        setData={setData}
        onNext={() => setStep(STEPS.health)}
        onBack={() => setStep(STEPS.introduction)}
      />
    ),
    [STEPS.health]: (
      <Health
        healthStatus={data.healthStatus}
        onSetHealthStatus={healthStatus => setData({ healthStatus })}
        onNext={() => setStep(['healthy', 'suspect'].includes(data.healthStatus) ? STEPS.conditions : STEPS.instructions)}
        onBack={() => setStep(STEPS.form)}
      />
    ),
    [STEPS.conditions]: (
      <Conditions
        conditions={data.conditions}
        onSetConditions={conditions => setData({ conditions })}
        onNext={() => setStep(STEPS.symptoms)}
        onBack={() => setStep(STEPS.health)}
      />
    ),
    [STEPS.symptoms]: (
      <Symptoms
        symptoms={data.symptoms}
        onSetSymptoms={symptoms => setData({ symptoms })}
        onNext={() => setStep(STEPS.instructions)}
        onBack={() => setStep(STEPS.conditions)}
      />
    ),
    [STEPS.instructions]: (
      <Instructions
        onNext={() => requestMicPermission().then(() => setStep(STEPS.record))}
      />
    ),
    [STEPS.record]: (
      <Record
        data={data}
        onDone={() => setStep(STEPS.done)}
        onBack={() => setStep(STEPS.form)}
        addBlob={addBlob}
      />
    ),
    [STEPS.done]: <Finish data={data} blobs={blobs} />
  }

  return (
    <>
      <div className="Container">
        <Layout id="logo">
          <img src={logo} alt="VoiceMed logo" />
          VoiceMed
        </Layout>

        <Layout key={step}>{components[step]}</Layout>
      </div>
    </>
  )
}

export default () => {
  const [step, setStep] = useState(STEPS.introduction)
  const [blobs, setBlobs] = useState({})
  const [data, setDataObject] = useState({
    healthStatus: null,
    age: null,
    gender: 'f',
    conditions: {},
    symptoms: {}
  })

  const setData = object => setDataObject({ ...data, ...object })

  const addBlob = (name, blob) =>
    setBlobs({
      ...blobs,
      [name]: blob
    })

  return (
    <App
      setStep={setStep}
      step={step}
      data={data}
      setData={setData}
      blobs={blobs}
      addBlob={addBlob}
    />
  )
}
